module.exports = __webpack_public_path__ + "img/traitsniper.e1325219.jpeg";